export { default } from './BrochureSearch.component';
